import { useNavigate } from 'react-router-dom'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import axios from 'axios'
import styles from '../../../styles/FormContacts.module.css'

let etatnom = 'valide'
let etatemail = 'valide'
let etatmessage = 'valide'
let etatrgpd = 'valide'

const FormContacts = () => {
  const navigate = useNavigate()
  return (
    <Formik
      initialValues={{ nom: '', email: '', messagecontact: '', rgpd: false }}
      validate={(values) => {
        const errors = {}
        if (!values.nom) {
          etatnom = 'erreur'
          errors.nom = 'Saisie requise.'
        } else if (
          !/^[a-zA-Zéèàê\- ]+(?:[-'\\s][a-zA-Zéèàê\- ]+)*$/i.test(values.nom)
        ) {
          etatnom = 'erreur'
        } else {
          etatnom = 'valide'
          if (values.nom === 'admin') {
            navigate('/FormAdminActualite')
          }
        }

        if (!values.email) {
          errors.email = 'Saisie requise.'
          etatemail = 'erreur'
        } else if (
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
        ) {
          errors.email = 'Adresse email invalide.'
          etatemail = 'erreur'
        } else {
          etatemail = 'valide'
        }
        if (!values.messagecontact) {
          errors.messagecontact = 'Saisie requise.'
          etatmessage = 'erreur'
        } else {
          etatmessage = 'valide'
        }
        if (values.rgpd === false) {
          errors.rgpd = 'Accord requis.'
          etatrgpd = 'erreur'
        } else {
          etatrgpd = 'valide'
        }
        return errors
      }}
      onSubmit={async (values, { resetForm, setSubmitting }) => {
        const donneesenvoyees = {}

        donneesenvoyees.Sujet = 'Message contact Duo Danse.'
        donneesenvoyees.msgHtml =
          '<!DOCTYPE html>' +
          '<html lang="fr">' +
          '<head>' +
          '<meta http-equiv="Content-Type" content="text/html; charset=iso-8859-1">' +
          '<title>Contact Duo Danse</title>' +
          '</head>' +
          '<body>' +
          '<div style="width: 640px; border:4px groove black;">' +
          '<p style="text-align: center; font-size:12px;"><b><u>Contact Duo Danse</u></b></p>' +
          '<p style="font-size:12px; margin:10px;"><u>Message de</u> : ' +
          values.nom +
          '<br>' +
          values.email +
          '</p>' +
          '<p style="font-size:11px; margin:10px;">' +
          values.messagecontact +
          '</p>' +
          '</div>' +
          '</body>' +
          '</html>'
        donneesenvoyees.msgTxtBrut =
          'Message contact Duo Danse.\r\n' +
          values.nom +
          '\r\n' +
          values.email +
          '\r\n' +
          values.messagecontact
        donneesenvoyees.listeDestinataires = 'duodanse@yahoo.fr'
        donneesenvoyees.adresseReponse = values.email

        try {
          const res = await axios.post(
            './php/envoimailsmtp.php',
            donneesenvoyees
          )
          if (res.status === 200) {
            alert('Votre message a bien été envoyé.')
            setSubmitting(false)
            resetForm()
          } else {
            alert("Votre message n'a pas été envoyé.")
          }
        } catch (err) {
          alert('Erreur lors de l’envoi')
        }
      }}
    >
      {({ isSubmitting }) => (
        <div className={styles.blocFormulaire}>
          <div className={styles.blockForm}>
            <Form className={styles.form}>
              <div className={styles.columns}>
                <label className={styles.label}>Nom:</label>
                <Field
                  type="text"
                  name="nom"
                  id="nom"
                  className={`${styles.textInput} ${etatnom === 'erreur' ? styles.erreur : etatnom === 'valide' ? styles.valide : ''}`}
                  placeholder="Votre nom complet"
                />
                <ErrorMessage
                  name="nom"
                  component="div"
                  className={styles.error}
                />
              </div>

              <div className={styles.columns}>
                <label className={styles.label}>E-mail:</label>
                <Field
                  type="email"
                  name="email"
                  id="email"
                  className={`${styles.emailInput} ${etatemail === 'erreur' ? styles.erreur : etatemail === 'valide' ? styles.valide : ''}`}
                  placeholder="Votre adresse e-mail"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className={styles.error}
                />
              </div>

              <div className={styles.columns}>
                <label className={styles.label}>Message:</label>
                <Field
                  as="textarea"
                  name="messagecontact"
                  id="messagecontact"
                  className={`${styles.messageInput} ${etatmessage === 'erreur' ? styles.erreur : etatmessage === 'valide' ? styles.valide : ''}`}
                  placeholder="Votre message."
                />
                <ErrorMessage
                  name="messagecontact"
                  component="div"
                  className={styles.error}
                />
              </div>

              <div className={styles.columns}>
                <div className={styles.enligne}>
                  <Field
                    type="checkbox"
                    name="rgpd"
                    id="rgpd"
                    className={`${styles.checkboxInput} ${etatrgpd === 'erreur' ? styles.erreur : etatrgpd === 'valide' ? styles.valide : ''}`}
                  />
                  <label
                    className={styles.politiqueConfidentialiteCheckLabel}
                    htmlFor="rgpd"
                  >
                    En soumettant ce formulaire, j'accepte que les informations
                    saisies soient exploitées dans le cadre strict de ma
                    demande.
                  </label>
                </div>
                <ErrorMessage
                  name="rgpd"
                  component="div"
                  className={styles.error}
                />
              </div>

              <button
                type="submit"
                className={styles.buttonSubmit}
                disabled={isSubmitting}
              >
                Envoyer
              </button>

              <div className={styles.msgPolitiqueConfidentialite}>
                DUO DANSE s'engage à ce que la collecte et le traitement de vos
                données, effectués à partir de notre site{' '}
                <a href="/" className={styles.rgpdLink}>
                  duodanse33.fr
                </a>
                , soient conformes au règlement général sur la protection des
                données (RGPD) et à la loi Informatique et Libertés. Pour
                connaître et exercer vos droits, notamment de retrait de votre
                consentement à l'utilisation des données collectées par ce
                formulaire, veuillez consulter notre politique de
                confidentialité.
              </div>
            </Form>
          </div>
        </div>
      )}
    </Formik>
  )
}

export default FormContacts
